{
  "name": "Trailer Master",
  "dbName": "trailer_master",
  "columns": [
    {
      "fieldName": "trailerNumber",
      "displayName": "Trailer Number",
      "dataType": "STRING",
      "thStyleConfig": {
        "width": "90px"
      }
    },
    {
      "fieldName": "vendor.name",
      "displayName": "Vendor",
      "dataType": "STRING",
      "thStyleConfig": {
        "width": "350px"
      }
    },
    {
      "fieldName": "vehicleType.name",
      "displayName": "Vehicle",
      "dataType": "STRING",
      "thStyleConfig": {
        "width": "110px"
      }
    },
    {
      "fieldName": "active",
      "dbName": "active",
      "displayName": "Status",
      "dataType": "BOOLEAN",
      "valueMap": {
        "true": "Active",
        "false": "Inactive"
      },
      "styleConfig": {
        "type": "status"
      }
    },
    {
      "fieldName": "createdDate",
      "displayName": "Created Date",
      "dataType": "DATETIME"
    },
    {
      "fieldName": "createdBy",
      "displayName": "Created By",
      "dataType": "STRING",
      "styleConfig": {
        "type": "user-avatar"
      }
    },
    {
      "fieldName": "modifiedDate",
      "displayName": "Modified Date",
      "dataType": "DATETIME",
      "sortable": true
    },
    {
      "fieldName": "modifiedBy",
      "dbName": "modified_by",
      "displayName": "Modified By",
      "dataType": "STRING",
      "styleConfig": {
        "type": "user-avatar"
      }
    }
  ],
  
    "filterConfig": {
    "filterFields": [
      {
        "name": "TRAILER_NUMBER_CONTAINS",
        "displayLabel": "Name",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "CONTAINS": "TRAILER_NUMBER_CONTAINS"
        }
      },
  
      {
        "name": "ACTIVE_EQUALS",
        "displayLabel": "Active",
        "dataType": "BOOLEAN",
        "operatorToFilterMap": {
          "EQ": "ACTIVE_EQUALS"
        }
      }
    
    ],
    "useNewContract": true
  },
  
  "searchBarConfig": {
    "placeHolder": "Search Trailer Number ",
    "filters": [
      {
        "name": "TRAILER_NUMBER_CONTAINS",
        "alias": "trailer_name"
      }
    ]
  }
}
